// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iFtc","content":"styles_content__3Znpa","row":"styles_row__--jiX","footer":"styles_footer__MU58U","phraseLength":"styles_phraseLength__33r2Y"};